import React from 'react';
import PropTypes from 'prop-types';
import { resolve } from '@cvent/nucleus-dynamic-css';
import removeKeys from '../../utils/removeKeys';
import GridStyles from './styles/Grid.less';

/**
* Top level component of the flexbox grid layout.
* LESS Style object set as default classes context
*/
class Grid extends React.Component {
  static displayName = 'Grid';
  static propTypes = {
    /* Breakpoint to change flow and size of row/cols */
    breakPoint: PropTypes.oneOf([
      'large', 'medium', 'small'
    ]),
    /** Child Row/Column components to render */
    children: PropTypes.node
  };
  static childContextTypes = {
    grid: PropTypes.object
  };
  static defaultProps = {
    classes: GridStyles
  };
  getChildContext() {
    return {
      grid: {
        classes: this.props.classes,
        style: this.props.style,
        breakPoint: this.props.breakPoint
      }
    };
  }

  render() {
    const { children } = this.props;
    return (
      <div
        {...removeKeys(this.props, ['classes', 'style', 'breakPoint', 'children'])}
        {...resolve(this.props, 'grid')}>
        {children}
      </div>
    );
  }
}


export default Grid;
